import type { GameEvent } from "../../engine/types";

export const FISH_EVENTS: readonly GameEvent[] = [
  {
    id: "f_egg_current",
    archetypes: ["FISH"],
    stages: ["egg"],
    weight: 6,
    text: "คุณเป็นไข่เม็ดจิ๋ว ลอยอยู่ท่ามกลางไข่อีกนับพัน",
    choices: [
      {
        label: "ลอยไปตามกระแสน้ำ",
        outcomes: [
          { chance: 0.8, text: "กระแสน้ำพาคุณไปยังที่ปลอดภัย", effects: { move: "near", health: 5 } },
          { chance: 0.2, text: "ฝูงปลาเล็กว่ายผ่านมากินไข่ไปจำนวนมาก คุณรอดมาได้", effects: { safety: -10 } },
        ],
      },
    ],
  },
  {
    id: "f_larva_drift",
    archetypes: ["FISH"],
    stages: ["newborn", "larva"],
    weight: 8,
    text: "คุณลอยไปตามกระแสน้ำพร้อมพี่น้องนับพัน",
    choices: [
      {
        label: "กินแพลงก์ตอนรอบตัว",
        outcomes: [
          { chance: 0.8, text: "แพลงก์ตอนตัวจิ๋วเต็มไปหมด คุณกินจนอิ่ม", effects: { fullness: 35 } },
          { chance: 0.2, text: "แมงกะพรุนลอยผ่านมา หนวดของมันเฉี่ยวตัวคุณ", effects: { fullness: 20, health: -20, cause: "predator" } },
        ],
      },
      {
        label: "ว่ายเข้าหาที่หลบภัย",
        outcomes: [
          { chance: 0.8, text: "คุณซ่อนตัวในกอสาหร่ายได้ทัน", effects: { safety: 15, fullness: 10 } },
          { chance: 0.2, text: "ในกอสาหร่ายมีปลาตัวใหญ่ซ่อนอยู่ก่อนแล้ว", effects: { death: "predator" } },
        ],
      },
    ],
  },
  {
    id: "f_school",
    archetypes: ["FISH"],
    stages: ["juvenile", "adult"],
    weight: 6,
    text: "ฝูงปลาขนาดใหญ่ว่ายผ่านมา",
    choices: [
      { label: "เข้าร่วมฝูง", outcomes: [{ chance: 1, text: "อยู่กลางฝูงช่วยให้นักล่าเลือกเป้าหมายยาก", effects: { safety: 15 } }] },
      { label: "ว่ายเดี่ยวต่อไป", outcomes: [{ chance: 1, text: "อาหารไม่ต้องแบ่งใคร แต่ก็ต้องระวังตัวเอง", effects: { fullness: 15, safety: -10 } }] },
    ],
  },
  {
    id: "f_feeding",
    archetypes: ["FISH"],
    stages: ["juvenile", "adult"],
    weight: 9,
    text: "ใกล้ๆ มีอาหารอยู่มากมาย",
    choices: [
      {
        label: "พุ่งเข้าไปกิน",
        outcomes: [
          { chance: 0.75, text: "คุณกินจนอิ่ม", effects: { fullness: 35 } },
          { chance: 0.25, text: "ปลาตัวใหญ่กว่าแย่งไปก่อน", effects: { fullness: 10, safety: -10 } },
        ],
      },
      { label: "เก็บกินรอบๆ อย่างระวัง", outcomes: [{ chance: 1, text: "ได้ไม่มากแต่ปลอดภัย", effects: { fullness: 20, safety: 5 } }] },
    ],
  },
  {
    id: "f_hook",
    archetypes: ["FISH"],
    stages: ["juvenile", "adult"],
    weight: 2,
    threatenedWeight: 2,
    text: "มีหนอนตัวอ้วนลอยนิ่งอยู่กลางน้ำ ดูน่ากินเหลือเกิน",
    choices: [
      {
        label: "งับเลย",
        outcomes: [
          { chance: 0.4, text: "อร่อย! ไม่มีอะไรผิดปกติ", effects: { fullness: 20 } },
          { chance: 0.5, text: "มีเบ็ดซ่อนอยู่ คุณดิ้นจนหลุดมาได้แต่ปากฉีก", effects: { health: -25, cause: "human" } },
          { chance: 0.1, text: "สายเบ็ดดึงคุณขึ้นจากน้ำ", effects: { death: "human" } },
        ],
      },
      { label: "ไม่ไว้ใจ ว่ายผ่านไป", outcomes: [{ chance: 1, text: "คุณว่ายผ่านมันไปโดยไม่หันกลับไปมอง" }] },
    ],
  },
  {
    id: "f_spawning_run",
    archetypes: ["FISH"],
    stageTags: ["adult"],
    requires: { notFlags: ["has_mate"] },
    weight: 5,
    text: "ถึงฤดูวางไข่ ปลาชนิดเดียวกับคุณเริ่มมารวมตัวกัน",
    choices: [
      {
        label: "ว่ายไปยังแหล่งวางไข่",
        outcomes: [
          { chance: 0.7, text: "คุณไปถึงแหล่งวางไข่และเจอคู่", effects: { move: "far", fullness: -15, addFlags: ["has_mate"] } },
          { chance: 0.3, text: "การเดินทางไกลทำให้หมดแรงก่อนถึงที่หมาย", effects: { move: "near", fullness: -20, health: -10 } },
        ],
      },
      { label: "อยู่ที่เดิม", outcomes: [{ chance: 1, text: "คุณหากินต่ออย่างสบายใจ", effects: { fullness: 10 } }] },
    ],
  },
];
